import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectIsProfessionalSearchPromoVariant2Visible } from '../../../selectors/selectIsProfessionalSearchPromoVariant2Visible';
import { selectIsProfessionalSearchPromoVariant3Visible } from '../../../selectors/selectIsProfessionalSearchPromoVariant3Visible';

import { SummaryHeaderContainer } from './containers/SummaryHeaderContainer';
import { SummaryTableViewButtonContainer } from './containers/SummaryTableViewButtonContainer';
import { SummaryMapViewButtonContainer } from './containers/SummaryMapViewButtonContainer';
import { SummarySortDropdownContainer } from './containers/SummarySortDropdownContainer';
import { ModerateLinkButtonContainer } from '../ModerateButtonContainer';
import { SummaryProfessionalSearchContainer } from './containers/SummaryProfessionalSearchContainer';
import { SummarySection } from '../../components/Summary';

export function SummaryContainer() {
  const isProfessionalSearchPromoVisible = useSelector(selectIsProfessionalSearchPromoVariant2Visible);
  const isTableViewButtonVisible =
    !isProfessionalSearchPromoVisible && !useSelector(selectIsProfessionalSearchPromoVariant3Visible);

  return (
    <SummarySection
      leftColumn={
        <>
          <SummaryHeaderContainer />
          <SummarySortDropdownContainer />
          <SummaryMapViewButtonContainer />
          {isTableViewButtonVisible && <SummaryTableViewButtonContainer />}
        </>
      }
      rightColumn={
        <>
          <ModerateLinkButtonContainer />
          {isProfessionalSearchPromoVisible && <SummaryProfessionalSearchContainer />}
        </>
      }
    />
  );
}
